import {formatedPrice} from "../../utils/common";
import {AriaLabelMessages} from "../../utils/consts";

export const getPreloaderTemplate = () => `<div class="preloader js-show-more-preloader"></div>`;

export const getInteriorTemplate = ({name, url, tag, image, description, isReady}) => {
  return `<li class="interiors__item">
    ${isReady ? `<span class="interiors__cathegory">Готовый интерьер</span>` : ``}
    <a href="${url}" class="interiors__img-box">
      <img src="${image}" alt="" width="340" height="335" class="interiors__img">
    </a>
    <p class="interiors__tag">${tag}</p>
    <a href="${url}" class="interiors__link link-dot">Читать полностью</a>
    <h2 class="interiors__name">${name}</h2>
    <p class="interiors__desc">${description}</p>
  </li>`;
};

export const getBlogTemplate = ({name, url, date, userDate, tag, image}) => {
  return `<li class="blog__item">
    <div class="blog__img-box">
      <img src="${image}" alt="${name}" width="340" height="141" class="blog__img">
    </div>
    <div class="blog__inner">
      <p class="blog__tag">${tag}</p>
      <time class="blog__date" datetime="${date}">${userDate}</time>
      <h2 class="blog__name">${name}</h2>
      <a href="${url}" class="blog__link link-dot link-dot--blog">Читать полностью</a>
    </div>
  </li>`;
};

export const getAuthorTemplate = ({name, avatar, description, url, works}) => {
  return `<li class="authors__item">
    <div class="authors__img-box">
      <img src="${avatar}" alt="${name}" class="authors__img">
    </div>
    <div class="authors__text-content">
      <h2 class="authors__name">${name}</h2>
      <p class="authors__about">${description}</p>
      <a href="${url}" class="authors__all-works">Смотреть все работы</a>
    </div>
    <div class="authors__works works">
      <h3 class="visually-hidden">Работы автора</h3>
      <ul class="works__list">
        ${works.map((work) => getWorksTemplate(work)).join(``)}
      </ul>
    </div>
  </li>`;
};

const getWorksTemplate = ({image, name, url}) => {
  return `<li class="works__item">
    <a href="${url}" class="works__link">
      <div class="works__img-box">
        <img src="${image}" alt="" width="104" height="156" class="works__img">
      </div>
      <p class="works__name">${name}</p>
    </a>
  </li>`;
};

export const getProductCardTemplate = ({
  id,
  name,
  tag,
  url,
  imageFull,
  imageCanvas,
  isFavorite,
  isNew,
  salePrice,
  price,
  isOptions,
}) => {
  return `<li class="cathegory__item">
    <a href="${url}" class="category__img-ratio-box">
      <picture class="cathegory__img-box cathegory__img-box--canvas">
        <img src="${imageCanvas}" alt="${name}" width="89" height="134" class="cathegory__img">
      </picture>
      <picture class="cathegory__img-box cathegory__img-box--full">
        <img src="${imageFull}" alt="${name}" width="89" height="134" class="cathegory__img">
      </picture>
      <div class="cathegory__user-block">
        <button class="cathegory__button js-add-favorite ${
          isFavorite ? `active` : ``
        }" aria-label="${
    isFavorite ? AriaLabelMessages.REMOVE : AriaLabelMessages.ADD
  }" data-id="${id}">
          <svg class="cathegory__icon" width="21" height="18">
            <use xlink:href="/img/sprite.svg#icon-favorite"></use>
          </svg>
        </button>
      </div>
    </a>
    <div class="cathegory__item-inner">
      ${isNew ? `<span class="cathegory__new">Новинка</span>` : ``}
      <div class="cathegory__link-box">
        <a href="${url}" class="cathegory__link ${isNew ? `cathegory__link--new` : ``}">${name}</a>
      </div>
      <p class="cathegory__tag">${tag}</p>
      <div class="cathegory__price-box">
        <p class="cathegory__price">${isOptions ? `от ` : ``}${
    salePrice ? formatedPrice(salePrice) : formatedPrice(price)
  } <span class="cathegory__currency">₽</span></p>
        ${
          salePrice
            ? `<p class="cathegory__old-price">${formatedPrice(
                price,
              )} <span class="cathegory__currency">₽</span></p>`
            : ``
        }
      </div>
    </div>
  </li>`;
};
